export default __webpack_public_path__ + "static/media/specialization.502138e5.svg";